export const OPEN_PREVIEW = 'openPreview' // 打开预览图
export const CLOSE_PREVIEW = 'openPreview' // 关闭预览图
